import { createContext, useContext } from 'react'

const ShadowContext = createContext(null)

function ShadowProvider({ shadowRoot, children }) {
  return (
    <ShadowContext.Provider value={shadowRoot}>
      {children}
    </ShadowContext.Provider>
  )
}
function useShadowRoot() {
  const ctx = useContext(ShadowContext)
  if (!ctx) {
    throw new Error('useShadowRoot must be used inside ShadowProvider')
  }
  return ctx
}

// eslint-disable-next-line react-refresh/only-export-components
export { useShadowRoot, ShadowProvider }